module.exports = __webpack_public_path__ + "img/Icon-feather-printer.53050913.svg";